export default "__VITE_ASSET__ff8abcd1__"